import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import { Edit, Trash, More } from "@rsuite/icons";
import BlockRoundIcon from "@rsuite/icons/BlockRound";
import CheckRoundIcon from "@rsuite/icons/CheckRound";
import React, { useRef, useState } from "react";
import { Popover, Dropdown, IconButton, Whisper } from "rsuite";
import ViewCommercialModal from "./ViewCommercial";
import { useDispatch } from "react-redux";
import { setActionData } from "../../../redux/userActionData";
import { useNavigate } from "react-router-dom";
import { statusArr } from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { ContentRoutes } from "../../../navigation/NavConstant";

const CommercialSingleAction = ({
  commercialData,
  onDeleteCommercial,
  onPublishCommercial,
  permission,
  ...props
}: {
  commercialData: any;
  onDeleteCommercial: Function;
  onPublishCommercial: Function;
  permission: any;
}) => {
  const { t } = useTranslation();
  const commercialRef = useRef({});
  const dispatch = useDispatch();
  const [openModalByName, setOpenModalByName] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openPublishModal, setOpenPublishModal] = useState(false);
  const [publishMessage, setPublishMessage] = useState("");
  const ecryptedCompId = encryptUrl(`${commercialData.id}`);

  const commercialUpdateLink = ContentRoutes.UPDATE_COMMERCIAL.replace(
    ":id",
    ecryptedCompId.toString()
  );

  const navigate = useNavigate();
  const publishText =
    commercialData.status == statusArr.active
      ? t("UNPUBLISH").toLowerCase()
      : t("PUBLISH").toLowerCase();
  const pMessage = t("CONFIRM_ACTION", {
    action:
      commercialData.status == statusArr.active
        ? t("UNPUBLISH").toLowerCase()
        : t("PUBLISH").toLowerCase(),
    entity: t("COMMERCIAL").toLowerCase(),
  });
  const publishIcon =
    commercialData.status == statusArr.inactive ? (
      <BlockRoundIcon />
    ) : (
      <CheckRoundIcon />
    );

  const renderMenu = (
    {
      onClose,
      left,
      top,
      className,
    }: { onClose: any; left: any; top: any; className: any },
    ref:
      | ((instance: HTMLDivElement | null) => void)
      | React.RefObject<HTMLDivElement>
      | null
      | undefined
  ) => {
    const handleSelect = (eventKey: any) => {
      setOpenModalByName(eventKey);
      dispatch(setActionData(commercialData));

      onClose();
    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item eventKey={"view-commercial"}>
            {t("VIEW")}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Popover>
    );
  };

  function handleEditAction() {
    navigate(`${commercialUpdateLink}`);
  }

  return (
    <div>
      {permission.update && (
        <>
          <IconButton
            appearance="subtle"
            onClick={handleEditAction}
            title={t("UPDATE")}
            icon={<Edit />}
          />
        </>
      )}
      {permission.delete && (
        <>
          <IconButton
            onClick={() => {
              commercialRef.current = commercialData;
              setOpenDeleteModal(true);
            }}
            icon={<Trash />}
            title={t("DELETE")}
            size="md"
          />
        </>
      )}
      {permission.publish && (
        <>
          <IconButton
            onClick={() => {
              commercialRef.current = commercialData;
              setOpenPublishModal(true);
              setPublishMessage(pMessage);
            }}
            icon={publishIcon}
            title={publishText}
            size="md"
          />
        </>
      )}
      <Whisper
        placement="topEnd"
        trigger="click"
        speaker={renderMenu}
        preventOverflow={true}
      >
        <IconButton appearance="subtle" icon={<More />} />
      </Whisper>
      {openModalByName === "view-commercial" && (
        <ViewCommercialModal
          status={openModalByName === "view-commercial" ? true : false}
          toggle={setOpenModalByName}
        />
      )}
      <AlertModal
        open={openDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            onDeleteCommercial(commercialRef);
            setOpenDeleteModal(false);
          } else {
            setOpenDeleteModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION", {
          action: t("DELETE").toLowerCase(),
          entity: t("COMMERCIAL").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("DELETE").toLowerCase(),
        })}
      />
      <AlertModal
        open={openPublishModal}
        handleClose={(e: any) => {
          if (e == true) {
            onPublishCommercial(commercialRef);
            setOpenPublishModal(false);
          } else {
            setOpenPublishModal(false);
          }
        }}
        displayText={publishMessage}
      />
    </div>
  );
};

export default CommercialSingleAction;
